module.exports = __webpack_public_path__ + "img/stock4.ebae8058.png";